import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { RxCross1 } from 'react-icons/rx';
import { Button, Card, CardBody, CardHeader, Col, Label, Row, TabContent, TabPane } from 'reactstrap';

import { GET_BOOKING_DETAILS_EMPTY } from '../../../../../../../../../store/actions';
import { Constant } from '../../../../../../../../Helpers/constant';

export default function Summary({ details, currentSelectedBooking, title }) {
  useEffect(() => {
    scrollToSection('summary-section');
  }, [details]);

  const scrollToSection = elementName => {
    const section = document.getElementById(elementName);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <Row id="summary-section">
        <Col xxl={12}>
          <Card>
            <CardHeader>
              <h4 className="card-title mb-0 flex-grow-1 fw-semibold fs-5">
                {title?.split(' ')?.[0] ?? ''} -{' '}
                <span className="fw-normal text-decoration-underline">
                  {currentSelectedBooking?.name || currentSelectedBooking?.clientName || currentSelectedBooking?.firstName}
                </span>{' '}
              </h4>
            </CardHeader>

            <CardBody>
              <Row>
                {details?.result?.map((details, index) => (
                  <Col md={3}>
                    <div className="mb-2 d-flex flex-column">
                      {details?.heading && (
                        <>
                          <Label className="custom-section-label">
                            {details?.icon && <img src={details?.icon} />}
                            {details?.heading || '-'}
                          </Label>
                        </>
                      )}
                      <Label className="custom-section-text">
                        {details?.metaInfo?.type === 'location' && (
                          <span
                            className="location-type-value"
                            onClick={() => {
                              const { lat, long } = details?.metaInfo || {};
                              const googleMapsUrl = `https://www.google.com/maps?q=${lat},${long}&ll=${lat},${long}&z=14`;

                              window.open(googleMapsUrl, '_blank');
                            }}
                          >
                            {details?.value || '-'}
                            {details?.metaInfo?.icon && <img src={details?.metaInfo?.icon} alt="Location Icon" />}
                          </span>
                        )}

                        {details?.metaInfo?.type === 'pills' && (
                          <div className="pills-type-values-container">
                            {details?.value?.split(',')?.map((pills, index) => (
                              <span className="pills-type-value" key={index}>
                                {pills || '-'}
                              </span>
                            ))}
                          </div>
                        )}

                        {!['pills', 'location']?.includes(details?.metaInfo?.type) && (
                          <span style={{ color: details?.metaInfo?.color || '#121639' }}>{details?.value || '-'}</span>
                        )}
                      </Label>
                    </div>
                  </Col>
                ))}
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
}
